export const Achieves = () => (
  <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" fill="black" fillOpacity={0.56}>
    <path
      fill="black"
      fillOpacity={0.56}
      d="M6 3v6c0 2.97 2.16 5.43 5 5.91V19H8v2h8v-2h-3v-4.09c2.84-.48 5-2.94 5-5.91V3zm10 5H8V5h8z"
    />
  </svg>
);
